// extracted by mini-css-extract-plugin
export default {"outer":"NoOrderHistory_outer__jX9ue","noOrderimg":"NoOrderHistory_noOrderimg__8nucY","noorderhistory_text":"NoOrderHistory_noorderhistory_text__-LEoU"};